// extracted by mini-css-extract-plugin
export default {"loaderBox":"Loader_loaderBox__+Qyud"};